'use client';

/**
 * Global Error Boundary Component
 * Handles errors during server-side rendering and root-level errors
 * This wraps the entire app including the root layout
 */
export default function GlobalError({ error, reset }) {
  return (
    <html lang="en">
      <body>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            padding: '20px',
            backgroundColor: '#f9fafb',
          }}
        >
          <div
            style={{
              textAlign: 'center',
              maxWidth: '400px',
            }}
          >
            <div
              style={{
                fontSize: '60px',
                marginBottom: '16px',
              }}
            >
              ⚠️
            </div>

            <h1
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#111827',
                marginBottom: '12px',
              }}
            >
              Application Error
            </h1>

            <p
              style={{
                fontSize: '16px',
                color: '#6b7280',
                marginBottom: '24px',
              }}
            >
              A critical error occurred. Please refresh the page or try again later.
            </p>

            <button
              onClick={() => reset()}
              style={{
                backgroundColor: '#000000',
                color: '#ffffff',
                border: 'none',
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '600',
                borderRadius: '8px',
                cursor: 'pointer',
                marginRight: '12px',
              }}
            >
              Try Again
            </button>

            <button
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: '#ffffff',
                color: '#000000',
                border: '1px solid #d1d5db',
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '600',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
